import { render, staticRenderFns } from "./UserEditTabSocial.vue?vue&type=template&id=6f156018"
import script from "./UserEditTabSocial.vue?vue&type=script&lang=js"
export * from "./UserEditTabSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports